import React, { FC } from "react";
import useOutsideClick from "hooks/click-outside";
import pinImage from "assets/images/svgs/ambassador/Learn-Local-Pin.svg";
import giftCardImage from "assets/images/svgs/ambassador/$5 Gift Card.svg";
import notebookImage from "assets/images/svgs/ambassador/Notebook or Journel.svg";
import toteBagImage from "assets/images/svgs/ambassador/Totel Bag.svg";
import waterBottleImage from "assets/images/svgs/ambassador/Water Bottle.svg";

interface Successpopup {
  isOpen: boolean;
  onClose: () => void;
}

const Successpopup: FC<Successpopup> = ({ isOpen, onClose }) => {
  const modalRef = useOutsideClick(onClose);

  if (!isOpen) return null;

  return (
    <div className="fixed  inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 px-4"
    style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className="relative bg-white px-6 py-8 rounded-xl shadow-lg w-[90%] sm:w-[50%] md:w-[40%] lg:w-[30%] xl:w-[20%] transform scale-100 transition-transform duration-300"
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3  w-8 h-8 flex items-center justify-center bg-transparent"
        >
          ✕
        </button>

       

        <h2 className="text-xl font-bold text-center mb-4 text-black">
          Success
        </h2>
        <p className="text-center text-gray-700 mb-6 text-sm sm:text-base leading-relaxed">
          Your parcel will be delivered within 2-5 working days.
        </p>

        <div className="mt-6 flex justify-center w-full">
          <button
            onClick={onClose}
            className="bg-ambassadorBlue text-white px-24 py-4 rounded-full font-semibold w-full sm:w-auto"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default Successpopup;
